"use client";

import { useEffect } from "react";

/**
 * Reports one "Lost in space." render to `/api/telemetry/not-found`.
 * Mounted only from the not-found pages; the boundary is inlined into
 * every page's tree but not mounted until a 404 actually shows, so a
 * mount is the reliable signal (see the route for why a server log in
 * the component is not). Fire-and-forget, never affects the render.
 */
export function NotFoundBeacon() {
  useEffect(() => {
    try {
      const payload = JSON.stringify({
        path: window.location.pathname,
        referrer: document.referrer || null,
      });
      const url = "/api/telemetry/not-found";
      if (typeof navigator.sendBeacon === "function") {
        navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
        return;
      }
      void fetch(url, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: payload,
        keepalive: true,
      }).catch(() => {});
    } catch {
      // Telemetry must never break the 404 screen.
    }
  }, []);
  return null;
}
